export const ROUTE_LOGIN = 'login';
export const ROUTE_AUTH = 'auth';
export const ROUTE_AUTH_LOGIN = 'login';
export const ROUTE_AUTH_FORGOT_PASS = 'forgot-password'
export const ROUTE_AUTH_RESET_PASS = 'resetPassword'
export const ROUTE_DASHBOARD = 'dash';
export const ROUTE_DASH_USERS = 'user-list';
export const ROUTE_DASH_COMPANIES = 'company';
export const ROUTE_DASH_DEPARTMENTS = 'department';
export const ROUTE_DASH_CONTRACTORS = 'contractor';
export const ROUTE_DASH_GROUPS = 'group-management';
export const ROUTE_DASH_TASKS = 'tasks';
export const ROUTE_DASH_DATA_VALIDATION = 'history-data-validation';
export const ROUTE_DASH_ACTUAL_LOADING = 'actual-loading';
export const ROUTE_DASH_USER_TRAFFIC_LOG = 'user-traffic-log';
export const ROUTE_DASH_REPORT_TCM = 'report-tcm';
export const ROUTE_DASH_REPORT_BEK = 'report-bek';
export const ROUTE_DASH_DAILY_LOADING_POINT = 'daily-elevation';
export const ROUTE_DASH_REPORT_IMM = 'report-imm';
export const ROUTE_DASH_REPORT_BARGE_CHECKLIST = 'report-barge-checklist';
export const ROUTE_DASH_REPORT_TRIP_COUNT = 'report-trip-count';
export const ROUTE_DASH_BLASTING_REPORT = 'blasting-report';
export const ROUTE_DASH_STOCK_OPNAME = 'stock-opname';
export const ROUTE_SUPPORT_REQ_LIST = 'support-requests';
export const ROUTE_CONFORMITY_LIST = 'conformity-reports';
export const ROUTE_NOTIFICATIONS = 'notifications';

// MAINTENANCE & ERRORS
export const ROUTE_ERR_MAINTENANCE = 'maintenance';
export const ROUTE_ERR_OFFLINE = 'offline';
export const ROUTE_ERR_TIMEOUT = 'timeout';
